/**
 * Client-side file saving.
 *
 * Endpoints that require authentication cannot be reached with a plain
 * `<a href download>`: a browser navigation carries no `Authorization` header,
 * so the request arrives anonymous and 401s. Fetch the file through the API
 * client instead, then hand the resulting blob to `saveBlob`.
 */

/** Save a blob to the user's disk under `filename`. */
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  try {
    anchor.click();
  } finally {
    anchor.remove();
    URL.revokeObjectURL(url);
  }
}
